import { makeStyles } from '@material-ui/core'
import classNames from 'classnames'
import React, { FC } from 'react'

export interface CellProps {
  className?: string
}

const useStyles = makeStyles(theme => ({
  cell: {
    padding: '25px 12px 32px'
  }
}))
const EnhancedCell: FC<CellProps> = ({ className, children }) => {
  const classes = useStyles()
  return <div className={classNames(classes.cell, className)}>{children}</div>
}

export default EnhancedCell
